import { render, staticRenderFns } from "./evaluate.vue?vue&type=template&id=08f8e432&scoped=true"
import script from "./evaluate.vue?vue&type=script&lang=js"
export * from "./evaluate.vue?vue&type=script&lang=js"
import style0 from "./evaluate.vue?vue&type=style&index=0&id=08f8e432&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f8e432",
  null
  
)

export default component.exports